import { configureStore } from "@reduxjs/toolkit";
import transactionReducer from "../Reducers/transactionReducer";
import userStatusReducer from "../Reducers/userStatusReducer";
import strategyReducer from "../Reducers/strategyReducer";
import authReducer from "../Reducers/authReducer";

export const store = configureStore({
  reducer: {
    transaction: transactionReducer,
    userStatus: userStatusReducer,
    strategy: strategyReducer,
    user: authReducer,
  },
});
